import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ScrollToTop from "../Components/ScrollToTop";

// Frontend Layout
import FrontendLayout from "../Layouts/FrontendLayout";
import HomePage from "../Frontend/Screens/Home";
import TermsConditionsPage from "../Frontend/Screens/TermsCondition";
import PrivacyPolicyPage from "../Frontend/Screens/PrivacyPolicy";
import PricingPage from "../Frontend/Screens/Pricing";
import CancellationRefundPolicyPage from "../Frontend/Screens/CancellationRefundPolicy";

// Authentication 
import AuthenticationPage from "../Auth/Authentication";
import PageLayout from "../Layouts/PageLayout";
import DashboardPage from "../Pages/Dashboard";
import SessionPage from "../Pages/Session";

// Subcription 
import SubscriptionPage from "../Pages/Subscription";

// Institutions 
import InstitutionMainPage from "../Pages/Institutions/Index";
import InstitutionListPage from "../Pages/Institutions/Screens/InstitutionList";

// Coupons 
import CouponsPage from "../Pages/Coupons";

// Academics
import AcademicMainPage from "../Pages/Academics/Index";
import StudentInformationPage from "../Pages/Academics/Screens/StudentInformation";
import ClassroomPage from "../Pages/Academics/Screens/Classrooms";
import StudentAttendencePage from "../Pages/Academics/Screens/StudentAttendence";
import AddStudentPage from "../Pages/Academics/Screens/AddStudent";
import ClassroomDetailsPage from "../Pages/Academics/Screens/ClassroomDetails";

// Finance Management 
import FinanceManagementMainPage from "../Pages/FinanceManagement/Index";
import FeeCollectionPage from "../Pages/FinanceManagement/Screens/FeeCollection";
import FeeTransactionsPage from "../Pages/FinanceManagement/Screens/FeeTransactions";
import FeesStructurePage from "../Pages/FinanceManagement/Screens/FeesStructure";
import DiscountPage from "../Pages/FinanceManagement/Screens/Discount";
import BankAccountPage from "../Pages/FinanceManagement/Screens/BankAccounts";
import AddFeesStructure from "../Pages/FinanceManagement/Screens/AddFeesStructure";
import DiscountFinePage from "../Pages/FinanceManagement/Screens/DiscountFine";

// Communication 
import CommunicationMainPage from "../Pages/Communication/Index";
import MessagingPage from "../Pages/Communication/Screens/Messaging";
import InstitutionWalletsPage from "../Pages/Communication/Screens/InstitutionWallets";
import ControlCenterPage from "../Pages/Communication/Screens/ControlCenter";

// Staff Management 
import StaffManagementMainPage from "../Pages/StaffManagement/Index";
import StaffInformationPage from "../Pages/StaffManagement/Screens/StaffInformation";
import AddStaffPage from "../Pages/StaffManagement/Screens/AddStaff";

// Settings 
import SettingsMainPage from "../Pages/Settings/Index";
import RolesPermissionsPage from "../Pages/Settings/Screens/RolePermission";
import AddRolePermissionPage from "../Pages/Settings/Screens/AddRolePermissions";
import ProfileSettingPage from "../Pages/Settings/Screens/ProfileSettings";
import TimeTableSettingsPage from "../Pages/Settings/Screens/TimeTableSettings";
import StudentPage from "../Pages/Settings/Screens/Student";
import StaffPage from "../Pages/Settings/Screens/Staff";
import SectionFieldsPage from "../Pages/Settings/Screens/SectionFields";
import SubjectSettingsPage from "../Pages/Settings/Screens/SubjectSettings";
import StateCityPage from "../Pages/Settings/Screens/StateCities";
import SubscriptionSettingPage from "../Pages/Settings/Screens/SubscriptionSetting";
import AccountSettingPage from "../Pages/Settings/Screens/AccountSetting";

import AlumniPage from "../Pages/Alumni";
import BillingPage from "../Pages/Billing";

//Report
import ReportMainPage from "../Pages/Reports/Index";
import SchoolSthrengthPage from "../Pages/Reports/Screens/SchoolStrength";
import AcademicsPage from "../Pages/Reports/Screens/Academics";
import StudentWiseAcademicPage from "../Pages/Reports/Screens/StedentWiseAcademic";
import TeacherWiseAcademicPage from "../Pages/Reports/Screens/TeacherWiseAcademic";
import ClassWiseAcademicPage from "../Pages/Reports/Screens/ClassWiseAcademic";

import StudentReportPage from "../Pages/Reports/Screens/StudentReport";
import OverViewPage from "../Pages/Reports/Screens/OverView";
import ClassWisePage from "../Pages/Reports/Screens/ClassWise";
import StudentWisePage from "../Pages/Reports/Screens/StudentWise";

import StaffReportPage from "../Pages/Reports/Screens/StaffReport";
import StaffOverViewPage from "../Pages/Reports/Screens/StaffOverView";
import TeachingStaffPage from "../Pages/Reports/Screens/TeachingStaff";
import NonTeachingStaffPage from "../Pages/Reports/Screens/NonTeachingStaff";

// Transport
import TransportMainPage from "../Pages/Transport/Index";
import TransportOverviewPage from "../Pages/Transport/Screens/Overview";
import PassengersPage from "../Pages/Transport/Screens/Passengers";
import StopagesPage from "../Pages/Transport/Screens/Stopages";
import VehiclesPage from "../Pages/Transport/Screens/Vehicles";
import VehicleStaffsPage from "../Pages/Transport/Screens/VehicleStaffs";
import VehicleRoutesPage from "../Pages/Transport/Screens/VehicleRoutes";
import AddRoutesPage from "../Pages/Transport/Screens/AddRoutes";

// Hostel Management 
import HostelManagementMainPage from "../Pages/HostelManagement/Index";
import HostelOverviewPage from "../Pages/HostelManagement/Screens/Overview";
import HostelResidentsPage from "../Pages/HostelManagement/Screens/Residents";
import HostelRoomsPage from "../Pages/HostelManagement/Screens/HostelRooms";
import HostelBuildingsPage from "../Pages/HostelManagement/Screens/HostelBuildings";

// Expense Management
import AccountingMainPage from "../Pages/Accounting/Index";
import ExpenseManagementpage from "../Pages/Accounting/Screens/ExpenseManagement";
import EventDetailsPage from "../Pages/Accounting/Screens/EventDetails";
import RetailerDetailsPage from "../Pages/Accounting/Screens/RetailDetails";
import StockManagementPage from "../Pages/Accounting/Screens/StockManagement";

// Library Management
import LibraryMainPage from "../Pages/LibraryManagement/Index";
import OverviewPage from "../Pages/LibraryManagement/Screens/Overview";
import BookCatelogPage from "../Pages/LibraryManagement/Screens/BookCatelog";
import LibraryMembersPage from "../Pages/LibraryManagement/Screens/LibraryMembers";


const Routers = () => {
    return (
        <>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<FrontendLayout />} >
                        <Route index element={<HomePage />} />
                        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="terms-conditions" element={<TermsConditionsPage />} />
                        <Route path="pricing" element={<PricingPage />} />
                        <Route path="cancellation-refund-policy" element={<CancellationRefundPolicyPage />} />
                    </Route>
                    <Route path="auth" element={<AuthenticationPage />} />
                    <Route path="subcription" element={<SubscriptionPage />} />
                    <Route path="admin" element={<PageLayout />}>
                        <Route path="" element={<Navigate to="dashboard" />} />
                        <Route path="dashboard" element={<DashboardPage />} />
                        <Route path="sessions" element={<SessionPage />} />
                        <Route path="institutions" element={<InstitutionMainPage />}>
                            <Route path="" element={<Navigate to="institution-list" />} />
                            <Route path="institution-list" element={<InstitutionListPage />} />
                        </Route>
                        <Route path="coupons" element={<CouponsPage />} />
                        <Route path="reports" element={<ReportMainPage />}>
                            <Route path="" element={<Navigate to="school-strength" />} />
                            <Route path="school-strength" element={<SchoolSthrengthPage />}>
                                <Route path="" element={<Navigate to="student-report" />} />
                                <Route path="student-report" element={<StudentReportPage />}>
                                    <Route path="" element={<Navigate to="overview" />} />
                                    <Route path="overview" element={<OverViewPage />} />
                                    <Route path="class-wise" element={<ClassWisePage />} />
                                    <Route path="student-wise" element={<StudentWisePage />} />
                                </Route>
                                <Route path="staff-report" element={<StaffReportPage />}>
                                    <Route path="staffoverview" element={<StaffOverViewPage />} />
                                    <Route path="teaching-staff" element={<TeachingStaffPage />} />
                                    <Route path="non-teaching-staff" element={<NonTeachingStaffPage />} />
                                </Route>
                            </Route>
                            <Route path="academics" element={<AcademicsPage />}>
                                <Route path="student-wise-academic" element={<StudentWiseAcademicPage />} />
                                <Route path="teacher-wise-academic" element={<TeacherWiseAcademicPage />} />
                                <Route path="class-wise-academic" element={<ClassWiseAcademicPage />} />
                            </Route>
                        </Route>
                        <Route path="academics" element={<AcademicMainPage />}>
                            <Route path="student-information" element={<StudentInformationPage />} />
                            <Route path="classrooms" element={<ClassroomPage />} />
                            <Route path="student-attendence" element={<StudentAttendencePage />} />
                            <Route path="add-student" element={<AddStudentPage />} />
                            <Route path="classroom-details" element={<ClassroomDetailsPage />} />
                        </Route>
                        <Route path="finance-management" element={<FinanceManagementMainPage />}>
                            <Route path="fee-collection" element={<FeeCollectionPage />} />
                            <Route path="fee-transactions" element={<FeeTransactionsPage />} />
                            <Route path="add-fee-structure" element={<AddFeesStructure />} />
                            <Route path="fee-configuration" element={<FeesStructurePage />} />
                            <Route path="discount-fine" element={<DiscountFinePage />} />
                            <Route path="accounts" element={<BankAccountPage />} />
                        </Route>
                        <Route path="communication" element={<CommunicationMainPage />}>
                            <Route path="message-templates" element={<MessagingPage />} />
                            <Route path="institution-wallets" element={<InstitutionWalletsPage />} />
                            <Route path="control-center" element={<ControlCenterPage />} />
                        </Route>
                        <Route path="staff-management" element={<StaffManagementMainPage />}>
                            <Route path="staff-information" element={<StaffInformationPage />} />
                            <Route path="add-staff" element={<AddStaffPage />} />
                        </Route>
                        <Route path="hostel-management" element={<HostelManagementMainPage />}>
                            <Route path="hostel-overview" element={<HostelOverviewPage />} />
                            <Route path="residents" element={<HostelResidentsPage />} />
                            <Route path="hostel-rooms" element={<HostelRoomsPage />} />
                            <Route path="hostel-buildings" element={<HostelBuildingsPage />} />
                        </Route>
                        <Route path="transport-management" element={<TransportMainPage />}>
                            <Route path="overview" element={<TransportOverviewPage />} />
                            <Route path="passengers" element={<PassengersPage />} />
                            <Route path="stopages" element={<StopagesPage />} />
                            <Route path="vehicles" element={<VehiclesPage />} />
                            <Route path="staffs" element={<VehicleStaffsPage />} />
                            <Route path="routes" element={<VehicleRoutesPage />} />
                        </Route>
                        <Route path="library-management" element={<LibraryMainPage />}>
                            <Route path="" element={<Navigate to="library-overview" />} />
                            <Route path="library-overview" element={<OverviewPage />} />
                            <Route path="book-catelog" element={<BookCatelogPage />} />
                            <Route path="library-member" element={<LibraryMembersPage />} />
                        </Route>
                        <Route path="add-routes" element={<AddRoutesPage />} />
                        <Route path="settings" element={<SettingsMainPage />}>
                            <Route path="roles-permissions" element={<RolesPermissionsPage />} />
                            <Route path="role/:roleName" element={<AddRolePermissionPage />} />
                            <Route path="add-roles-permissions" element={<AddRolePermissionPage />} />
                            <Route path="time-tables" element={<TimeTableSettingsPage />} />
                            <Route path="subscription-setting" element={<SubscriptionSettingPage />} />
                            <Route path="state-cities" element={<StateCityPage />} />
                            <Route path="subject-settings" element={<SubjectSettingsPage />} />
                            <Route path="account-settings" element={<AccountSettingPage />} />
                            <Route path="profile-settings" element={<ProfileSettingPage />}>
                                <Route path="" element={<Navigate to="student" />} />
                                <Route path="student" element={<StudentPage />} />
                                <Route path="staff" element={<StaffPage />} />
                                <Route path="section-fields" element={<SectionFieldsPage />} />
                            </Route>
                        </Route>
                        <Route path="accounting" element={<AccountingMainPage />}>
                            <Route path="expense-management" element={<ExpenseManagementpage />} />
                            <Route path="event-details" element={<EventDetailsPage />} />
                            <Route path="retail-details" element={<RetailerDetailsPage />} />
                            <Route path="stock-management" element={<StockManagementPage />} />
                        </Route>
                        <Route path="alumni" element={<AlumniPage />} />
                        <Route path="billing" element={<BillingPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default Routers;
